import Keycloak from 'keycloak-js'

let _keycloak

function bindToVue2Prototype(Vue2Ctor) {
  if (Vue2Ctor?.prototype) {
    Vue2Ctor.prototype.$keycloak = _keycloak
  }
}

export function getKeycloak() {
  return _keycloak
}

export function initializeKeycloak({ config }) {
  return new Promise((resolve, reject) => {
    _keycloak = new Keycloak({
      url: config.url,
      realm: config.realm,
      clientId: config.clientId
    })

    _keycloak.init({
      onLoad: 'check-sso',
      checkLoginIframe: false,
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
    })
      .then(() => {
        resolve(_keycloak)
      })
      .catch((err) => {
        console.error('[Keycloak] Erreur d initialisation', err)
        reject(err)
      })
  })
}

const keycloakPlugin = {
  install(appOrVue2Ctor) {
    // Vue 2 support
    if (appOrVue2Ctor?.prototype) {
      appOrVue2Ctor.prototype.$keycloak = _keycloak
      return
    }
    // Vue 3 support
    if (appOrVue2Ctor?.config?.globalProperties) {
      appOrVue2Ctor.config.globalProperties.$keycloak = _keycloak
    }
  },

  // Backward-compatible signature:
  // - initialize(Vue, { config }) for Vue 2 code
  // - initialize({ config }) for Vue 3 code
  initialize(arg1, arg2) {
    const options = arg2 || arg1
    const maybeVue2Ctor = arg2 ? arg1 : null

    return initializeKeycloak(options).then((keycloak) => {
      if (maybeVue2Ctor) {
        bindToVue2Prototype(maybeVue2Ctor)
      }
      return keycloak
    })
  },

  getInstance() {
    return _keycloak
  },

  stopRefreshLoop() {}
}

export default keycloakPlugin
